module.exports = __webpack_public_path__ + "img/fst4fa53ebf.fa53ebf3.png";